import React, { FC, ReactElement } from 'react';
import styled from 'styled-components';

import './Element.scss';
import elementsClassInstance from './Elements';

export type ElementProps = {
  index: number | null;
  path: {
    slideIndex: number;
    comboIndex: number;
    setIndex: number;
    groupIndex: number;
    elementIndex: number | null;
    subElementIndex: number | null;
  } | null;
  editorPlugins: any | null;
  elementData: any;
};

type ElementDesignedProps = {
  separatorPlaceholder: string | null;
  horizontalAlignment: string;
  isAnchorActive?: boolean;
  selectedLinkType?: string | null;
  label: string;
};

export const ElementDesigned = styled.div<ElementDesignedProps>`
  &.elementWrapper {
    &[label='Text'],
    .element.RichText {
      display: flex;
      justify-content: inherit;
      width: 100%;
    }
  }
  &[data-anchor-trigger] {
    cursor: ${(props) =>
      (props.isAnchorActive && !props.selectedLinkType) || props.selectedLinkType !== 'none'
        ? 'pointer'
        : 'auto'};
  }
  &.elementWrapper {
    .element.RichText {
      display: flex;
      justify-content: inherit;
    }
    .content {
      text-align: left;
      ${(props) =>
        props.horizontalAlignment === 'center' &&
        `
            text-align: center;
        `};
    }
  }
`;

const Element: FC<ElementProps> = ({ ...props }): ReactElement => {
  let isEditor = props.editorPlugins;
  let elementObject = elementsClassInstance.getElement(props.elementData.name);
  let Element = elementObject[props.elementData.name];

  const settings = elementObject.settings;
  const elementOptions = elementObject.options;
  const elementLabel = elementObject.label;

  function handleClick(event: any) {
    const triggerElement: any = event.target;
    const currentTriggerElement: HTMLElement | null =
      triggerElement.closest('[data-anchor-trigger]');
    const currentTrigger = currentTriggerElement
      ? currentTriggerElement.getAttribute('data-anchor-trigger')
      : null;
    const anchorTargetElement = document.querySelector(
      '[data-anchor-target="' + currentTrigger + '"]',
    );
    if (
      !anchorTargetElement ||
      (props.elementData.data.selectedLinkType &&
        props.elementData.data.selectedLinkType !== 'anchor')
    )
      return;
    if (!isEditor) anchorTargetElement.scrollIntoView();
  }

  if (isEditor) {
    const ElementEditor = require('./ElementEditor').default;
    return (
      <ElementEditor
        {...props}
        element={Element}
        settings={settings}
        options={elementOptions}
        label={elementLabel}
      />
    );
  } else {
    return (
      <ElementDesigned
        className={'elementWrapper '}
        data-anchor-trigger={props.elementData.data.anchorTrigger}
        label={elementLabel}
        data-anchor-target={
          props.elementData.data.isAnchorActive ? props.elementData.data.anchorName : ''
        }
        separatorPlaceholder={null}
        onClick={(event) => {
          handleClick(event);
        }}
        horizontalAlignment={props.elementData.data.horizontalAlignment}
        isAnchorActive={props.elementData.data.isAnchorActive}
        selectedLinkType={props.elementData.data.selectedLinkType}>
        <Element {...props.elementData.data} editorPlugins={null} />
      </ElementDesigned>
    );
  }
};

export default Element;
